import { render, staticRenderFns } from "./AdmComunicados.vue?vue&type=template&id=6e9cf10f&scoped=true&"
import script from "./AdmComunicados.vue?vue&type=script&lang=js&"
export * from "./AdmComunicados.vue?vue&type=script&lang=js&"
import style0 from "./AdmComunicados.vue?vue&type=style&index=0&id=6e9cf10f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9cf10f",
  null
  
)

export default component.exports